/** Renzo WithdrawQueue — per-user enumeration + cooldown.
 *  Address on chain 1: `0x5efc9d10e42fb517456f4ac41eb5e2ebe42c8918`. */
export const RenzoWithdrawQueueAbi = [
  {
    name: 'getOutstandingWithdrawRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'user' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'withdrawRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'user' },
      { type: 'uint256', name: 'index' },
    ],
    outputs: [
      { type: 'address', name: 'collateralToken' },
      { type: 'uint256', name: 'withdrawRequestNonce' },
      { type: 'uint256', name: 'amountToRedeem' },
      { type: 'uint256', name: 'ezETHLocked' },
      { type: 'uint256', name: 'createdAt' },
    ],
  },
  {
    name: 'coolDownPeriod',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
